import { useEffect } from 'react';
import { Col, Form, Row } from 'antd';

import { FieldByType, MilesText } from 'components';

import { RecursiveRequired } from 'types';

import { CompanySelect } from './CompanySelect';
import { retailerGenericFields, retailerPartnerFields } from './lib';
import { RetailerActions } from './RetailerActions';
import { RetailerDetails } from './RetailerDetails';

import { useFormValues } from '../../hooks';
import { IRetailerStore, retailerStore } from '../../store';

const { useForm } = Form;

export const RetailerForm = () => {
  const initialValues = retailerStore((state) => state.initialValues);

  const [form] = useForm<RecursiveRequired<IRetailerStore['initialValues']>>();

  useEffect(() => { form?.resetFields(); }, [initialValues]);

  const {
    enNotFilled,
    frNotFilled,
    // isManualThreshold,
    isEnabledBaseIssuance,
    isSaveBtnDisabled,
  } = useFormValues(form);

  return (
    <Form
      labelWrap
      name='offerForm'
      form={form}
      colon={false}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={initialValues}
    >
      <Row className='my-6'>
        <MilesText
          size='lg'
          className='font-semibold'
        >
          Generic Options
        </MilesText>
      </Row>

      <CompanySelect />

      <Row>
        {retailerGenericFields.map((field) => (
          <Col xs={24} key={field.label as string}>
            <FieldByType field={field} />
          </Col>
        ))}
      </Row>

      <RetailerDetails
        enNotFilled={enNotFilled}
        frNotFilled={frNotFilled}
      />

      <Row className='my-6'>
        <MilesText
          size='lg'
          className='font-semibold'
        >
          Partner Options
        </MilesText>
      </Row>

      <Row>
        {retailerPartnerFields(isEnabledBaseIssuance).map((field) => (
          <Col xs={24} key={field.label as string}>
            <FieldByType field={field} />
          </Col>
        ))}
      </Row>

      <RetailerActions
        // we need this for new retailer
        isSaveBtnDisabled={isSaveBtnDisabled}
      />
    </Form>
  );
};
